﻿<script>
  import { onMount, afterUpdate } from "svelte/internal";
  import {
    dispatchMountEvent,
    dispatchRenderEvent,
    compareCSVHeaders,
    getCSVColumnIndex,
    getCSVDisplayableHeaders
  } from "./services";
  import CSVUpload from "./CSVUpload.svelte";
  import Icon from "./Icons.svelte";

  export let _emitMount;
  export let name;
  export let recoverytypename;
  export let samplefileMonthly;
  export let samplefileAccount;

  // const
  let csvHeadersMonthly = [
    { name: "Aryza Segment ID", required: true },
    { name: "Recovery Month", required: true },
    { name: "Recovery Amount", required: true }
  ];
  let csvHeadersAccount = [
    { name: "Aryza Segment ID", required: true },
    { name: "Account Number", required: true },
    { name: "Payment Date", required: true },
    { name: "Payment Amount", required: true }
  ];

  // state
  let recoveryType;
  let modelElement;
  let isLoading = false;
  let requestList = [];
  let errors = [];
  let fileContent = [];
  let tableHeader = [];
  let tableBody = [];
  let dataValid = false;

  onMount(() => {
    if (_emitMount) {
      dispatchMountEvent();
    }
  });

  afterUpdate(() => {
    if (_emitMount) {
      dispatchMountEvent();
    }
  });

  $: {
    // previewing csv
    errors = [];
    tableHeader = [];
    tableBody = [];
    if (fileContent && fileContent.length > 0 && recoveryType.length) {
      // validate data
      const rawHeaders = fileContent[0];
      let missingHeaders;
      let headerIndex;

      // account
      if (recoveryType === "true") {
        missingHeaders = compareCSVHeaders(rawHeaders, csvHeadersAccount);
      } else {
        missingHeaders = compareCSVHeaders(rawHeaders, csvHeadersMonthly);
      }

      if (missingHeaders.length) {
        errors = ["Missing " + missingHeaders.join(", ") + " column(s)"];
      } else {
        // account
        if (recoveryType === "true") {
          csvHeadersAccount = getCSVDisplayableHeaders(
            rawHeaders,
            csvHeadersAccount
          );
          headerIndex = getCSVColumnIndex(rawHeaders, csvHeadersAccount);
          tableHeader = csvHeadersAccount.map(x => x.name);
        } else {
          // monthly
          csvHeadersMonthly = getCSVDisplayableHeaders(
            rawHeaders,
            csvHeadersMonthly
          );
          headerIndex = getCSVColumnIndex(rawHeaders, csvHeadersMonthly);
          tableHeader = csvHeadersMonthly.map(x => x.name);
        }

        // prepare body
        const bodyData = [];
        for (let i = 1; i < fileContent.length; i++) {
          const row = fileContent[i];
          const newRow = headerIndex.map(i => row[i]);

          // trim comment
          const commentIndex = newRow.length - 1;
          if (newRow[commentIndex].length > 30) {
            newRow[commentIndex] =
              newRow[commentIndex].substring(0, 30) + "...";
          }

          bodyData.push(newRow);
        }

        tableBody = bodyData;
      }
    }
  }
  $: {
    if (tableBody.length || tableHeader.length) {
      errors = [];
      dataValid = true;
    }
  }
  $: {
    if (errors.length) {
      dataValid = false;
    }
  }

  $: {
    // clear all
    if (recoveryType) {
      errors = [];
    }
  }
  const fileSelected = content => {
    fileContent = content;
  };
</script>

<div class="container container-lg-fluid container--no-gutters-mobile">
  <div class="card card--edge">
    <div class="card-header">
      <div class="row align-items-center">
        <div class="col-md">
          <h4 class="card-title mb-0">Import recoveries via .csv file</h4>
        </div>
        {#if samplefileMonthly && samplefileMonthly.length}
          <div class="col-auto">
            <a href={samplefileMonthly} target="_blank" class="btn-icon-start">
              <Icon icon="Download" class="icon icon-sm" />
              Monthly sample .csv
            </a>
          </div>
        {/if}
        {#if samplefileAccount && samplefileAccount.length}
          <div class="col-auto">
            <a href={samplefileAccount} target="_blank" class="btn-icon-start">
              <Icon icon="Download" class="icon icon-sm" />
              Account sample .csv
            </a>
          </div>
        {/if}
      </div>
    </div>
    <div class="card-body">
      <div class="row">
        <div class="col-md-6">
          <label class="font-weight-medium">
            Recovery type
            <span class="text-danger">*</span>
          </label>
          <select
            required
            name={recoverytypename}
            id={recoverytypename}
            bind:value={recoveryType}
            class="custom-select custom-select-lg">
            <option value="">Select recovery type</option>
            <option value="false">Monthly Recoveries</option>
            <option value="true">Account Recoveries</option>
          </select>
        </div>
      </div>
      <div class="pt-4" />
      {#if recoveryType === 'false'}
        <CSVUpload
          {name}
          maxsize="10"
          onFileSelected={fileSelected}
          {dataValid} />
      {:else if recoveryType === 'true'}
        <CSVUpload
          {name}
          maxsize="10"
          onFileSelected={fileSelected}
          {dataValid} />
      {/if}
    </div>
  </div>

  {#if errors.length}
    <div class="pt-4 pb-3" />
    <div class="alert alert-danger mb-0" role="alert">
      <div class="row no-gutters">
        <div class="col-auto">
          <Icon icon="XSolid" class="icon alert-icon" />
        </div>
        <div class="col">
          <h6 class="mb-2">
            The file was not imported. The following could not be processed:
          </h6>
          <ul class="m-0 p-0 pl-3">
            {#each errors as error}
              <li class="h6 mb-0 py-1">{error}</li>
            {/each}
          </ul>
        </div>
      </div>
    </div>
  {/if}
</div>
<!-- {#if tableHeader.length || tableBody.length}
  <div class="space-separator--md" />
  <div class="container container-max-fluid container--no-gutters-mobile">
    <div class="card">
      <div class="card-header">
        <h5 class="mb-0 font-italic">
          {tableBody.length} {tableBody.length === 1 ? 'Result' : 'Results'}
        </h5>
      </div>
      <div class="card-body p-0">
        <SortableTable
          header={tableHeader}
          body={tableBody}
          class="table-height-md table-sticky-header" />
      </div>
    </div>
  </div>
{/if} -->
